import { createContentPropTypes } from '../../../helpers/content';

const content = {
	wrapperTitle: 'Payment and transfers',
	title: 'Make payments using Bacs',
	description:
		'Bacs is the simple, secure and affordable way to make regular payments like wages and invoices directly into your employees’ or suppliers’ accounts.',
	addPayeeButtonTitle: 'Add new payee',
	noSearchResultMessage: 'No results',
	payeeSingularCountMessage:
		'Making more than one payment or transfer today? Select up to 150 payees or accounts to process in one transaction.',
	copyToAllButton: 'Apply to all',
	addButton: 'Add another payment or transfer',
	submissionDatePopperBody:
		'This is the date you’re planning to submit your payment to Bacs for processing. Please note that Bacs payments can’t be submitted on a weekend or bank holiday.',
	settlementDatePopperBody:
		'This is the date your money will come out of your account and reach the other account – if it’s completed and authorised on time.',
	bacsIdPopperBody:
		'This is the service user number that was issued to your company by Bacs. If you have more than one ID, simply select the one you want to use for this payment. ',
	paymentNamePopperBody:
		'Personalise this Bacs payment by giving it a unique name (such as ‘May wages’). This is the name that’ll appear on your payment history and when authorisation is required.',
	hmrcReferencePopperBody:
		'This is an optional reference (for wages and salaries only) that’s used to help HMRC match this person’s payments with PAYE data.  It may have been provided to you by HMRC or your payroll services supplier.',
	paymentsLimitMessage: 'You’ve now reached the maximum amount of Payees that you can process at the one time.',
	continueButtonText: 'Continue',
	amountInvalid: 'Enter the amount you want to move',
	paymentNameInvalid: 'Enter a payment name',
	hmrcReferenceInvalid:
		'Your HMRC reference is four characters long and can include letters, numbers, hyphens, full stops and forward slashes.',
	maxLimitExceededMessage: 'This exceeds the maximum amount of money you can move online per transaction.',
	bacsIdInvalid: 'Please select a Bacs ID',
	fromLabel: 'From',
	toLabel: 'To',
	submissionDateLabel: 'Submission Date',
	submissionDateDescription: 'When your payment request will be sent to Bacs',
	settlementDateLabel: 'Settlement Date',
	settlementDateDescription: 'When the money will be taken from your account and reach the other account',
	paymentNameLabel: 'Payment Name',
	paymentNameDescription: 'You can give this payment a unique name ',
	paymentNameRequirements: 'Max 18 characters',
	bacsIdLabel: 'Bacs ID',
	bacsIdDescription: 'The service user number issued by Bacs',
	referenceLabel: 'Reference (optional)',
	hmrcReferenceLabel: 'HMRC Reference (optional)',
	amountLabel: 'Amount',
	amountLabelTemplate: 'Amount (optional)',
	sameRefPopoverMsg:
		'We couldn’t apply this change to every reference as some references can’t be edited or left blank.',
	templateTitle: 'Create Bacs payment template',
	templateEditTitle: 'Edit Bacs payment template',
	templateDescription:
		'Set up your Bacs payment template by adding all the payees and payment details you want to include. Once your template’s been created and saved, you can make changes at any time. Please note that any templates you create here will only be available when you’re making a Bacs payment.',
	templateMakePaymentDescription:
		'Make a Bacs payment quickly and simply using the details you’ve saved in your template. You can make one-off changes for this payment below, but if you want to make permanent changes to your template, you’ll have to go back and edit it. Please remember that Bacs payments must be set up and authorised by 5.10pm to meet your planned submission and settlement dates',
	saveTemplateButtonText: 'Save',
	saveTemplateAndExitButtonText: 'Save and exit',
	saveTemplateAndMakePaymentButtonText: 'Save and make payment',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
